<template>
  <th class="py-2 px-3 align-middle font-heading text-heading-3xs text-neutral-950 text-left">
    <slot />
  </th>
</template>
